import m from "./index6.js";
import { resolveComponent as o, openBlock as n, createElementBlock as a, normalizeClass as t, createBlock as r, createVNode as f, createElementVNode as c, createCommentVNode as s } from "vue";
import "./index7.js";
import g from "../../../../_virtual/index.js";
const y = {
  key: 1,
  id: "header",
  class: "header"
}, C = { class: "phone-country-account-container" }, k = { class: "my-documents" }, H = {
  key: 0,
  class: "my-documents-link",
  href: "/mydocuments/"
};
function S(e, b, w, v, B, N) {
  const u = o("HeaderSkeleton"), l = o("HeaderLogo"), i = o("country-selector"), d = o("CSRPhoneNumber"), h = o("HeaderHelp"), p = o("HeaderAccount");
  return n(), a("header", {
    class: t(["header-container", e.bannerStyle.toLowerCase()])
  }, [
    e.arePropsUnavailable || !e.areTranslationsLoaded ? (n(), r(u, {
      key: 0,
      config: e.config
    }, null, 8, ["config"])) : (n(), a("div", y, [
      f(l, {
        onClickCapture: e.trackLogoClick,
        config: e.config
      }, null, 8, ["onClickCapture", "config"]),
      c("div", C, [
        e.config.showCountrySelector !== !1 && e.isSelectionBanner ? (n(), r(i, {
          key: 0,
          variant: e.CountryVariants.FlagWithExpansionOnHover,
          countries: e.location.countries,
          currentCountry: e.location.currentCountry,
          hasArrow: !1,
          showOnlyCurrentCountry: !0,
          class: "header-country header-selection-country-border"
        }, null, 8, ["variant", "countries", "currentCountry"])) : s("", !0),
        e.config.showPhoneNumber === !0 && e.csr.number !== "" ? (n(), r(d, {
          key: 1,
          showPhoneHours: !1,
          phoneNumber: e.csr.number,
          phoneHours: e.csr.hours,
          class: "header-phone",
          onClickCapture: e.trackPhoneNumberClick
        }, null, 8, ["phoneNumber", "phoneHours", "onClickCapture"])) : s("", !0),
        e.config.showHelpMenu !== !1 ? (n(), r(h, {
          key: 2,
          config: e.config,
          csr: e.csr,
          showHelpCenter: !e.isSelectionBanner,
          class: t(["header-help", [e.isSelectionBanner ? "header-selection-help-border" : ""]])
        }, null, 8, ["config", "csr", "showHelpCenter", "class"])) : s("", !0),
        e.config.showCountrySelector !== !1 && !e.isSelectionBanner ? (n(), r(i, {
          key: 3,
          variant: e.CountryVariants.FlagWithExpansionOnHover,
          countries: e.location.countries,
          currentCountry: e.location.currentCountry,
          class: "header-country"
        }, null, 8, ["variant", "countries", "currentCountry"])) : s("", !0),
        e.config.showAccountMenu !== !1 && (!e.isSelectionBanner || e.isSelectionBanner && e.user.isSignedIn) ? (n(), r(p, {
          key: 4,
          user: e.user,
          showMenuItems: !e.isSelectionBanner,
          config: e.config,
          class: t([
            "header-account",
            e.user.isSignedIn ? "header-signed-in" : "header-signed-out"
          ]),
          disableSendingSignInRequestsToOtherHosts: e.disableSendingSignInRequestsToOtherHosts
        }, null, 8, ["user", "showMenuItems", "config", "class", "disableSendingSignInRequestsToOtherHosts"])) : s("", !0),
        c("div", k, [
          e.config.showAccountMenu === !1 && e.config.showMyDocuments === !0 ? (n(), a("a", H, "My Documents")) : s("", !0)
        ])
      ])
    ]))
  ], 2);
}
const A = /* @__PURE__ */ g(m, [["render", S], ["__scopeId", "data-v-4cb4aac3"]]);
export {
  A as default
};
//# sourceMappingURL=index4.js.map
